import { render, staticRenderFns } from "./DiversityData.vue?vue&type=template&id=4fd053ab&"
import script from "./DiversityData.vue?vue&type=script&lang=ts&"
export * from "./DiversityData.vue?vue&type=script&lang=ts&"
import style0 from "./DiversityData.vue?vue&type=style&index=0&id=4fd053ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports